import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 22.06 20.3"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M19.39 3.19C17.26 1.1 14.2-.07 11.02 0 4.84 0 0 4.1 0 9.37c.11 2.85 1.58 5.5 3.87 7.09-.16.32-.37.63-.64.97-.29.39-.42.86-.35 1.32.07.48.33.91.75 1.22.04.03.08.06.13.08.33.16.65.25.95.25.18 0 .36-.03.52-.1 1.55-.48 2.74-1.05 3.78-1.82.62.1 1.32.18 2.04.18 6.08 0 11.03-4.19 11.03-9.33 0-2.21-.95-4.35-2.67-6.03Zm-8.36 13.68c-.74 0-1.49-.11-2.12-.21a.86.86 0 0 0-.67.17c-.95.76-2.05 1.31-3.57 1.78a.16.16 0 0 1-.08-.03.2.2 0 0 1-.03-.11c.55-.69.92-1.35 1.16-2.07a.84.84 0 0 0-.38-1c-2.15-1.23-3.55-3.56-3.65-6.06 0-4.29 4.1-7.65 9.34-7.65h.02c2.76-.06 5.35.93 7.16 2.7 1.39 1.36 2.16 3.08 2.16 4.83 0 4.21-4.19 7.64-9.34 7.64Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "6.2",
  cy: "9.51",
  r: "1.45",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "11.03",
  cy: "9.51",
  r: "1.45",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "15.86",
  cy: "9.51",
  r: "1.45",
  fill: "currentColor"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }